import './App.css';
import Home from './Components/Home/Home'
import Header from './Components/Header/Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from './Components/Footer/Footer';
import About from './Components/About/About';
import Contact from './Components/Contact/Contact';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Service from './Components/Service/Service';
import PrivateTour from './Components/PrivateTour/PrivateTour';
import OurFleet from './Components/OurFleet/OurFleet';
import Faq from './Components/Faq/Faq';

function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/service" element={<Service />} />
          <Route exact path="/privatetour" element={<PrivateTour />} />
          <Route exact path="/ourfleet" element={<OurFleet />} />
          <Route exact path="/faq" element={<Faq />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
